module.exports = __webpack_public_path__ + "img/folder_icon.246e3328.svg";